import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { mainColor } from 'theme/Theme';
import {
  aclPrefix,
  aclPoliciesPrefix,
  aclUsersGroupsPrefix,
  customersPrefix,
  datasheetsPrefix,
  documentsPrefix,
  productsPrefix,
  sitesPrefix,
  usersPrefix
} from 'routes/routes';
import { deleteAuth } from 'features/Auth/auth';
import { useRole } from 'roles/useRole';
import { useLicensedProducts } from 'roles/useLicensedProducts';
import { setAppMenuOpen, isAppMenuOpen } from './appMenu';

const ListOption: FC<{ prefix: string; text: string }> = ({ prefix, text }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();

  const isButton = (path: string): any => pathname !== path;

  const clickItem = useCallback(() => {
    history.push(prefix);
    dispatch(setAppMenuOpen(false));
  }, [dispatch, history, prefix]);

  return (
    <ListItem
      button={isButton(prefix)}
      onClick={clickItem}
      style={{ borderLeft: !isButton(prefix) ? 'solid 5px #F3216D' : '' }}
    >
      <ListItemText primary={text} />
    </ListItem>
  );
};

const AppMenuDrawer: FC<{}> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const open = useSelector(isAppMenuOpen);
  // TODO: refactor when we'll have real role management
  const { showAdmin, showCompany } = useRole();
  const { hasLedger, hasWarehouse } = useLicensedProducts();

  const logout = useCallback(() => {
    dispatch(deleteAuth());
    dispatch(setAppMenuOpen(false));
    history.push('/auth/signin');
  }, [dispatch, history]);

  return (
    <Drawer open={open} onClose={() => dispatch(setAppMenuOpen(false))}>
      <div style={{ display: 'flex', flex: 1, flexDirection: 'column', width: '250px' }}>
        {(showAdmin || showCompany) && (
          <List disablePadding>
            <ListSubheader color="primary" style={{ background: mainColor, color: 'white' }}>
              {t('menu.production')}
            </ListSubheader>
            <ListOption prefix={productsPrefix} text={t('menu.products')} />
            <ListOption prefix={sitesPrefix} text={t('menu.sites')} />
            <ListOption prefix={documentsPrefix} text={t('menu.documents')} />
            {hasWarehouse && (
              <ListItem button onClick={() => window.open(`${process.env.REACT_APP_WAREHOUSE_URL}`, '_blank')}>
                <ListItemText primary={t('menu.warehouse')} />
              </ListItem>
            )}
            {hasLedger && (
              <>
                <ListSubheader color="primary" style={{ background: mainColor, color: 'white' }}>
                  {t('menu.accounting')}
                </ListSubheader>
                <ListItem button onClick={() => window.open(`${process.env.REACT_APP_LEDGER_URL}`, '_blank')}>
                  <ListItemText primary={t('menu.ledger')} />
                </ListItem>
              </>
            )}
            {/* <ListSubheader color="primary" style={{ background: mainColor, color: 'white' }}>
              {t('menu.datasheets')}
            </ListSubheader>
            <ListOption prefix={datasheetsPrefix} text={t('menu.datasheets reports')} />
            <ListOption prefix={`${datasheetsPrefix}/templates`} text={t('menu.datasheets templates')} /> */}
            <ListSubheader color="primary" style={{ background: mainColor, color: 'white' }}>
              {t('menu.people')}
            </ListSubheader>
            <ListOption prefix={usersPrefix} text={t('menu.managers and workers')} />
            <ListOption prefix={customersPrefix} text={t('menu.customers')} />
            <ListSubheader color="primary" style={{ background: mainColor, color: 'white' }}>
              {t('menu.acl')}
            </ListSubheader>
            <ListOption prefix={`${aclPrefix}${aclPoliciesPrefix}`} text={t('menu.acl policies')} />
            <ListOption prefix={`${aclPrefix}${aclUsersGroupsPrefix}`} text={t('menu.acl users groups')} />
          </List>
        )}
        <div style={{ display: 'flex', flex: '1' }} />
        <List disablePadding>
          <ListItem button style={{ background: '#F3216D', color: '#fff' }} onClick={logout}>
            <ListItemText>{t('menu.sign out')}</ListItemText>
          </ListItem>
        </List>
      </div>
    </Drawer>
  );
};

export { AppMenuDrawer };
